import { render, staticRenderFns } from "./SupportTicketParticipants.vue?vue&type=template&id=0ed4d459&"
import script from "./SupportTicketParticipants.vue?vue&type=script&lang=js&"
export * from "./SupportTicketParticipants.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports